// Ported verbatim from the LeadMailer Design System (components/overlays/Tooltip.jsx).
import React from 'react'

export interface TooltipProps {
  label: React.ReactNode
  side?: 'top' | 'bottom'
  children?: React.ReactNode
}

export function Tooltip({ label, side = 'top', children }: TooltipProps) {
  const [show, setShow] = React.useState(false)
  const pos: React.CSSProperties =
    side === 'bottom' ? { top: 'calc(100% + 6px)' } : { bottom: 'calc(100% + 6px)' }

  return (
    <span
      style={{ position: 'relative', display: 'inline-flex' }}
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
    >
      {children}
      {show && (
        <span
          role="tooltip"
          style={{
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)',
            ...pos,
            zIndex: 50,
            whiteSpace: 'nowrap',
            padding: '5px 9px',
            borderRadius: 'var(--radius-sm)',
            background: 'var(--gray-900)',
            color: 'var(--gray-50)',
            fontSize: 'var(--text-xs)',
            fontWeight: 'var(--weight-medium)' as React.CSSProperties['fontWeight'],
            boxShadow: 'var(--shadow-md)',
            pointerEvents: 'none',
          }}
        >
          {label}
        </span>
      )}
    </span>
  )
}
